<template>
  <!-- <div class="directTree" ref="chartdiv"></div> -->
  <div id="chartdiv" :style="`height: ${height}px`"></div>
</template>

<script>
import _ from "lodash";
import { mapState, mapGetters } from "vuex";

import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import * as am5hierarchy from "@amcharts/amcharts5/hierarchy";

import { REFINERY_COLORS } from "@/constants/colors";
import { DIRECT_TREE_TYPE, REFINERY_ID } from "@/constants";
import moment from "moment";

export default {
  name: "directTree",   
  props: {
    config: {type : Object},
    station: {type : Object},
    transferDataForDirectTree: {type : Array},
    isActive: {type : Boolean},
    height: {type : Number}
  },
  data() {
    return {
      dataForDirecTree : {
        name: this.station.name,
        children: []
      },
      isActiveChart: true,
      transferData: [],
      root: null,
      selectedNode: null
    };
  },
  async mounted() {    
    await this.setDataForRender()
  },
  computed: {
    ...mapState({
      // transfers: (state) => state.oilTransfer.oilTransfers,
    }),
  },
  watch: {
    async transferDataForDirectTree(newVal, oldVal) {
      if (!_.isEqual(newVal, oldVal)) {
        await this.setDataForRender()
      }
    },
    async station(newVal, oldVal) {
      this.selectedNode = newVal
    },
  },
  methods: {
    disposeRoot(divId) {
      am5.array.each(am5.registry.rootElements, function(root) {
        if (root && root.dom.id == divId) {
          root.dispose();
        }
      });
    },
    async init(data) {
     await am5.ready(() => {
        // Create root element
        this.disposeRoot("chartdiv");
        this.root = am5.Root.new("chartdiv");

        // Set themes
        this.root.setThemes([
          am5themes_Animated.new(this.root)
        ]);
        // console.log("data ::::: ", data);

        // Create wrapper container
        var container = this.root.container.children.push(am5.Container.new(this.root, {
          width: am5.percent(100),
          height: am5.percent(100),
          layout: this.root.verticalLayout
        }));

        // Create series
        var series = container.children.push(am5hierarchy.ForceDirected.new(this.root, {
          singleBranchOnly: false,
          downDepth: 1,
          initialDepth: 1,
          valueField: "value",
          categoryField: "name",
          childDataField: "children",
          centerStrength: 0.5,
          minRadius: 30,
          maxRadius: 60,
        }));
        series.nodes.template.set("tooltipText", "{name} : {value} ครั้ง");
        series.nodes.template.setup = (target) => {
          target.events.on("click", (ev) => {
            this.selectedNode = ev.target.dataItem.dataContext
          });
        }
        series.data.setAll([data]);
        series.set("selectedDataItem", series.dataItems[0]);
        
        // Make stuff animate on load
        series.appear(1000, 100);
      }); // end am5.ready()
    },
    async setDataForRender(){
      console.log("transferDataForDirectTree >>> ", this.transferDataForDirectTree);
      let dataForDirecTree = this.station
      dataForDirecTree.value = this.transferDataForDirectTree.length

      const count = _.countBy(this.transferDataForDirectTree, "vessel_id")
      const filterData = _.uniqBy(this.transferDataForDirectTree, ((o)=>{
        o.name = o.vessel.name
        o.value = _.get(count, `${o.vessel_id}`)
        return o.vessel_id
      }))
      // console.log("filterData >>>> ", filterData);
      dataForDirecTree.children = filterData
      console.log("dataForDirecTree >>>> ", dataForDirecTree);
      await this.init(dataForDirecTree)
    },

  },
};
</script>

<style>
.directTree {
  /* width: 120%; */
  height: 380px;
  font-family: "Prompt", sans-serif;
}
#chartdiv {
  width: 100%;
  /* height: 300px; */
  max-width: 100%;
}
</style>
